/* projects/speaker-platform/src/app/organisms/admin/seances-list/seances-list.component.scss */
.textslist__header {
  position: sticky;
  z-index: 3;
  top: 0;
  background-color: white;
}
.textslist__table thead {
  position: sticky;
  z-index: 2;
}
.textslist__table thead tr th {
  position: sticky;
  top: 0;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
  font-size: 14px;
  font-weight: 700;
}
.textslist__table__loader {
  display: inline-block;
  padding: 32px 0;
  transform: scale(2.5);
}
.textslist__table__empty {
  padding: 32px 0;
  text-align: center;
  color: #952626;
}
.textslist__table__select {
  position: relative;
}
.textslist__table__select--linked::before {
  display: inline-block;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  position: absolute;
  left: -18px;
  font-size: 12px;
  content: "\f0c1";
}
.textslist__table__select--match {
  background-color: rgba(255, 237, 0, 0.25);
}
.textslist__error {
  color: #952626;
  font-size: 14px;
}
.textslist__translationstatus {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: red;
}
.textslist__translationstatus--sent {
  background-color: #FFC107;
}
.textslist__translationstatus--done {
  background-color: #99FF74;
}
.seanceslist__loading {
  text-align: center;
  transform: scale(2);
  margin: 30px 0;
}
.seanceslist__table__row--canceled {
  --bs-table-bg: $disabled-background;
  background-color: #ADADAD;
}
.seanceslist__table__row--done {
  --bs-table-bg: $success-background;
  background-color: #99FF74;
}
.seanceslist__pdf {
  position: absolute;
  left: 999999px;
  top: -999999px;
  width: 100%;
  padding: 32px;
}
.seanceslist__pdf__item {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, max-content);
  grid-row-gap: 30px;
  margin-bottom: 30px;
}
.seanceslist__pdf__reference,
.seanceslist__pdf__phasevocale {
  background-color: #FFED00;
}
.seanceslist__pdf__reference {
  grid-area: 1/1/2/2;
}
.seanceslist__pdf__phasevocale {
  grid-area: 1/2/2/3;
}
.seanceslist__pdf__texte {
  grid-area: 2/1/3/3;
  border-bottom: 2px solid;
  padding-bottom: 30px;
}
.seanceslist__pdf__phonetique {
  grid-area: 3/1/4/2;
}
.seanceslist__pdf__consigne {
  grid-area: 3/2/4/3;
}
/*# sourceMappingURL=seances-list.component-6Z76ZKP2.css.map */
